import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { createClient } from '@supabase/supabase-js';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.detail || 'Invalid email or password');
    } finally {
      setLoading(false);
    }
  }
  const handleForgotPassword = async () => {
    try {
      console.log('Attempting reset for:', email);
      console.log('Site URL:', process.env.REACT_APP_SITE_URL);
      console.log('Supabase URL:', process.env.REACT_APP_SUPABASE_URL);

      const supabase = createClient(
        process.env.REACT_APP_SUPABASE_URL,
        process.env.REACT_APP_SUPABASE_ANON_KEY
      );

      console.log('Supabase client created');

      const { data, error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${process.env.REACT_APP_SITE_URL}/reset-password`
      });

      console.log('Reset result:', data, error);

      if (error) {
        setError('Error: ' + error.message);
        return;
      }

      setError('');
      alert('Password reset email sent — check your inbox.');
    } catch (err) {
      console.log('Reset password catch error:', err);
      setError('Could not send reset email: ' + err.message);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logo}>Transformation Companion</div>
        <div style={styles.tagline}>Coaching & Counseling</div>

        <h2 style={styles.title}>Welcome back</h2>

        {error && <div style={styles.error}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Email</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              style={styles.input}
              placeholder="you@example.com"
              required
            />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              style={styles.input}
              placeholder="••••••••"
              required
            />
          </div>
          <button
            type="submit"
            style={{...styles.btn, opacity: loading ? 0.7 : 1}}
            disabled={loading}
          >
            {loading ? 'Signing in...' : 'Sign in'}
          </button>
          <div style={{textAlign:'right', marginTop:'10px', marginBottom:'16px'}}>
          <span
            style={{fontSize:'13px', color:'#5C7A6B', cursor:'pointer'}}
            onClick={handleForgotPassword}
          >
            Forgot password?
          </span>
        </div>
        </form>

        <p style={styles.footer}>
          Don't have an account?{' '}
          <Link to="/signup" style={styles.link}>Sign up</Link>
        </p>
        <p style={{ ...styles.footer, marginTop: '8px' }}>
          Are you a client?{' '}
          <Link to="/client-login" style={styles.link}>Log in here</Link>
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    background: '#F8F5F0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: "'Figtree', sans-serif",
    padding: '20px',
  },
  card: {
    background: 'white',
    borderRadius: '16px',
    padding: '48px 40px',
    width: '100%',
    maxWidth: '420px',
    border: '1px solid #D8E0DC',
    boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
  },
  logo: {
    fontFamily: 'Georgia, serif',
    fontSize: '24px',
    fontWeight: '300',
    fontStyle: 'italic',
    color: '#C4956A',
    marginBottom: '4px',
  },
  tagline: {
    fontSize: '11px',
    color: '#8C9E98',
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    marginBottom: '32px',
  },
  title: {
    fontSize: '22px',
    fontWeight: '500',
    color: '#2D3A35',
    marginBottom: '24px',
  },
  formGroup: {
    marginBottom: '18px',
  },
  label: {
    display: 'block',
    fontSize: '12px',
    fontWeight: '500',
    textTransform: 'uppercase',
    letterSpacing: '0.07em',
    color: '#8C9E98',
    marginBottom: '8px',
  },
  input: {
    width: '100%',
    padding: '11px 14px',
    borderRadius: '8px',
    border: '1px solid #D8E0DC',
    background: '#F8F5F0',
    fontFamily: "'Figtree', sans-serif",
    fontSize: '14px',
    color: '#2D3A35',
    outline: 'none',
    boxSizing: 'border-box',
  },
 btn: {
    width: '100%',
    padding: '12px',
    borderRadius: '8px',
    border: 'none',
    background: '#5C7A6B',
    color: 'white',
    fontFamily: "'Figtree', sans-serif",
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    marginTop: '8px',
  },
    error: {
    background: '#F5EAEA',
    color: '#B85C5C',
    padding: '12px 16px',
    borderRadius: '8px',
    fontSize: '13.5px',
    marginBottom: '16px',
  },
  footer: {
    textAlign: 'center',
    fontSize: '13.5px',
    color: '#8C9E98',
    marginTop: '24px',
  },
  link: {
    color: '#5C7A6B',
    textDecoration: 'none',
    fontWeight: '500',
  },
};